import React from 'react';
import { Wrapper, Fields } from './styled';
import ActionBar from './components/ActionBar';
import Description from './components/Description';
import Resolution from './components/Resolution';
import References from './components/References';
import ImpactsTab from './components/ImpactsTab';
import ExternalId from './components/ExternalId';
import Policies from './components/Policies';
import CVEEditor from './components/CVE';

const GeneralTab = () => (
  <Wrapper>
    <Fields>
      <ActionBar />
      <Description />
      <Resolution />
      <References />
      <ImpactsTab />
      <ExternalId />
      <Policies />
      <CVEEditor />
    </Fields>
  </Wrapper>
);

export default GeneralTab;
